import styled from 'styled-components';
import { CustomThemeToken } from '@/theme/theme.utils';
import { breakpoints } from '@/utils/util-breakpoints';
import { StageCard } from '@/comp/StationStages/styled';

export const StyledLifecyclePage = styled.div<{ theme: { token: CustomThemeToken } }>`
    display: flex;
    flex-direction: column;
    gap: ${({ theme: { token } }) => token.marginXL}px;
    padding: ${({ theme: { token } }) => token.marginLG}px;
    width: 100%;
    .top-row {
        width: 100%;
        height: fit-content;
        display: flex;
        gap: ${({ theme: { token } }) => token.margin}px;
        ${StageCard} {
            width: 100%;
            border-radius: ${({ theme: { token } }) => token.borderRadius}px;
            margin: 0;
            padding: ${({ theme: { token } }) => token.paddingXS}px ${({ theme: { token } }) => token.padding}px;
        }
        @media (max-width: ${breakpoints.md}px) {
            flex-direction: column-reverse;
        }
    }
    .ant-skeleton-paragraph > li {
        height: 90px !important;
        & + li {
            margin-block-start: ${({ theme: { token } }) => token.marginXL}px !important;
        }
    }
    .lifecycle-container {
        height: 100%;
        overflow-y: scroll;
        display: flex;
        &::-webkit-scrollbar {
            display: none;
        }
        gap: ${({ theme: { token } }) => token.marginLG}px;
        @media (max-width: ${breakpoints.md}px) {
            flex-direction: column;
            gap: ${({ theme: { token } }) => token.margin}px;
        }
        .stages-container {
            display: flex;
            flex-direction: column;
            gap: ${({ theme: { token } }) => token.marginXL}px;
            width: 100%;
            height: fit-content;
            background: transparent;
            .ant-collapse-arrow {
                color: ${({ theme: { token } }) => token.colorText};
            }
            .ant-collapse-header {
                background: ${({ theme: { token } }) => token.colorBgContainer};
                align-items: center;
                padding: ${({ theme: { token } }) => token.marginLG}px;
                border-radius: ${({ theme: { token } }) => token.borderRadiusSM}px;
                font-size: ${({ theme: { token } }) => token.fontSizeHeading4}px;
                font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
            }
            .ant-collapse-content-box {
                padding: 0;
                border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px
            }
            .ant-collapse-item {
                border: none;
            }
            .ant-collapse-item-active > .ant-collapse-header {
                border-radius: ${({ theme: { token } }) => `${token.borderRadiusLG}px ${token.borderRadiusLG}px`} 0 0;
            }
            .ant-collapse-extra {
                width: 100%;
            }   
            .ant-collapse-expand-icon {
                height: auto;
                align-self: start;
            }
        }

        .progress-widget-container {
            display: flex;
            flex-direction: column;
            gap: ${({ theme: { token } }) => token.marginXXL}px;
        }
    }
`;